export default __webpack_public_path__ + "static/corporativo-icon-8c82054b5c6bb66f667b8160cc92f1fc.svg";